import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';
import { RruleParserPipe } from '../../../../filters/rrule-parser.pipe';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'r-rule-text',
  templateUrl: './r-rule-text.component.html',
  standalone: true,
  imports: [
    CommonModule, 
    DateTimeFormatPipe,
    RruleParserPipe
  ]
})
export class RRuleTextComponent {
  @Input() columnData = new BehaviorSubject(null)
  @Input() additionData = new BehaviorSubject(null)

  setFullDate(timeString: string) {
    const [hours, minutes] = timeString.split(':');
    const currentDate = new Date(new Date().toUTCString());
    currentDate.setHours(parseInt(hours));
    currentDate.setMinutes(parseInt(minutes));
    return currentDate;
  }
}
